import { render } from "./SelectTTPP.vue?vue&type=template&id=81970ce0"
import script from "./SelectTTPP.vue?vue&type=script&lang=js"
export * from "./SelectTTPP.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__